import React from 'react'
import MetaData from '../../utils/MetaData'

function Orders() {


  return (
    <>
      <MetaData
        title='My Bookings | Be Alright Krabi'
        description='View your bookings and order history on Be Alright Krabi.'
        canonicalUrl={`${window.location.origin}/user-bookings`}
        robots='noindex,nofollow'
      />
      <div>Orders</div>
    </>
  )
}

export default Orders